import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_027a3bac from 'nuxt_plugin_plugin_027a3bac' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_moment_1ac39d58 from 'nuxt_plugin_moment_1ac39d58' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_gtm_070a5316 from 'nuxt_plugin_gtm_070a5316' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_axios_62510780 from 'nuxt_plugin_axios_62510780' // Source: ./axios.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    return this.$root.$options.$nuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Coach, mediátor, kávé. Neked. Dr. Pápai Anitával","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"keywords","name":"keywords","content":"coach, Pápai Anita, dr, mediáció, life, pszichológia, business, coaching, jogász, válás"},{"hid":"author","name":"author","content":"Revext Bt."},{"hid":"title","name":"title","content":"Coach, mediátor, kávé. Neked. Dr. Pápai Anitával"},{"hid":"og:title","name":"og:title","content":"Coach, mediátor, kávé. Neked. Dr. Pápai Anitával"},{"hid":"description","name":"description","content":"Dr. Pápai Anita. Coach és mediátor. Otthonod kényelmében online, illetve személyesen egyaránt rendelkezésedre állok, maximális figyelemmel és empátiával."},{"hid":"og:description","name":"og:description","content":"Dr. Pápai Anita. Coach és mediátor. Otthonod kényelmében online, illetve személyesen egyaránt rendelkezésedre állok, maximális figyelemmel és empátiával."},{"hid":"og:site_name","name":"og:site_name","content":"https:\u002F\u002Fwww.coachandcoffee.hu"},{"hid":"og:site-name","name":"og:site-name","content":"Coach, mediátor, kávé. Neked. Dr. Pápai Anitával"},{"hid":"og:image","name":"og:image","property":"og:image","content":"https:\u002F\u002Fwww.coachandcoffee.hu\u002Fimg\u002Findex_coffee.png"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"href":"css\u002Fbootstrap.min.css","rel":"stylesheet","type":"text\u002Fcss"},{"href":"css\u002Fanimate.css","rel":"stylesheet","type":"text\u002Fcss"},{"href":"css\u002Fowl.carousel.css","rel":"stylesheet","type":"text\u002Fcss"},{"href":"css\u002Fstyle.css","rel":"stylesheet","type":"text\u002Fcss"},{"id":"colors","href":"css\u002Fcolors\u002Fscheme-01.css","rel":"stylesheet","type":"text\u002Fcss"},{"href":"css\u002Fcoloring.css","rel":"stylesheet","type":"text\u002Fcss"},{"rel":"preload","as":"style","onload":"this.onload=null;this.rel='stylesheet'","href":"https:\u002F\u002Fuse.fontawesome.com\u002Freleases\u002Fv6.2.0\u002Fcss\u002Fall.css","integrity":"sha384-fnmOCqbTlWIlj8LyTjo7mOUStjsKC4pOpQbqyi7RrhN7udi9RwhKkMHpvLbHG9Sr","crossorigin":"anonymous"}],"script":[{"type":"application\u002Fld+json","json":{"@context":"https:\u002F\u002Fschema.org\u002F","@type":"Person","name":"Dr. Pápai Anita","url":"https:\u002F\u002Fwww.coachandcoffee.hu","image":"https:\u002F\u002Fwww.coachandcoffee.hu\u002Fimg\u002Findex.jpg","sameAs":["https:\u002F\u002Fwww.facebook.com\u002Fcoachncoffee.foru","https:\u002F\u002Fwww.instagram.com\u002Fcoachncoffee_foru\u002F","https:\u002F\u002Fwww.linkedin.com\u002Fin\u002Fanita-p%C3%A1pai-72b4611b5\u002F","https:\u002F\u002Fatejhabosmindenit.hu"],"jobTitle":"Coach, Mediátor","worksFor":{"@type":"Organization","name":"Egyéni vállalkozó"}}},{"src":"js\u002Fjquery.min.js"},{"src":"js\u002Fbootstrap.min.js"},{"src":"js\u002Fwow.min.js"},{"src":"js\u002Fjquery.isotope.min.js"},{"src":"js\u002Feasing.js"},{"src":"js\u002Fowl.carousel.js"},{"src":"js\u002Fvalidation.js"},{"src":"js\u002Fjquery.magnific-popup.min.js"},{"src":"js\u002Fenquire.min.js"},{"src":"js\u002Fjquery.stellar.min.js"},{"src":"js\u002Fdesignesia.js"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-NSK5WB9')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-NSK5WB9&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_027a3bac === 'function') {
    await nuxt_plugin_plugin_027a3bac(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_1ac39d58 === 'function') {
    await nuxt_plugin_moment_1ac39d58(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_070a5316 === 'function') {
    await nuxt_plugin_gtm_070a5316(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_62510780 === 'function') {
    await nuxt_plugin_axios_62510780(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
